// Local, user-configurable KPI profile definitions.
// Seed/config data for the Project Setup modal.

export type KpiProfile = {
  kpi_profile_guid: string;
  name: string;
  description?: string;
};

export const kpiProfiles: KpiProfile[] = [
  {
    kpi_profile_guid: "default_v1",
    name: "Default KPI Profile",
    description: "Standard Summary/Schedule/Finance/Mission/Data KPIs.",
  },
  {
    kpi_profile_guid: "mission_heavy_v1",
    name: "Mission-Heavy Profile",
    description: "Higher weighting on mission/outcomes.",
  },
  {
    kpi_profile_guid: "delivery_heavy_v1",
    name: "Delivery-Heavy Profile",
    description: "Higher weighting on schedule/finance execution.",
  },
];
